import type { FaireProductEntity } from "../../entity_types/product";

export const p_98v2qowkio: FaireProductEntity = {
  token: "p_98v2qowkio",
  type: "product",
  name: "Banner Dark Blend, 12 oz Organic",
  brandToken: "b_3angyj4q6y",
  brandName: "Sightglass Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/2952538fd9bcf3f128be4fa8282edbe03ed893d5f28fcff28550121742265340.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ca8b01d5d93fe920b18da5054645450e7cc243bccb09f4935f81fa2a32a058c6.png",
    "https://cdn.faire.com/fastly/443a70ba743c00b079f7e372b3cc355b79a72c0c0266c0829510f4a5b1cf40d5.jpeg",
    "https://cdn.faire.com/fastly/e136cb9c51e8bf15ed806bbf4ecc8f46f7650e750620a3d644182d77c7023bf9.jpeg",
    "https://cdn.faire.com/fastly/9ccf66ccd4b10f0cd7dd2ce43179cc5dd5c882b40a89225c905ea3b3dc126352.jpeg"
  ],
  priceDollars: 12.15,
  description: "Banner Dark is our seasonally rotating blend of fully washed Central and South American coffees sourced for their deep, full-bodied sweetness, attributes which respond beautifully to a more robust roast. This blend is meant to appeal to those who enjoy a deeper, richer flavor.\n• Taste notes: Dark chocolate and brown sugar meet rich undertones of vanilla and maple, with a heavier body and lower acidity in the cup\n• Roast profile: Medium-dark\n• Recommended brew methods: French Press, Aeropress, V60, Cold Brew\n• Shelf life: All our whole bean coffees are roasted fresh to order and stamped with the roast date. We encourage selling the coffee within 60 days of the roast date for optimal freshness and flavor. For questions about freshness or how to brew a certain coffee, please send us a message or email us directly at [redacted-email]!",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:44.960Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
